import ASTBlock from "../ASTBlock";
import Blockly from 'blockly';

export default class AlvikLineSensor extends ASTBlock {
    constructor(color) {
        super(color, "alvik_line_sensor")
        this.predefinedInputs = {}
        this.TOP_LEVEL = undefined
    }

    addToBlockly() {
        var json = {
            "tooltip": "",
            "helpUrl": "",
            "message0": "Wert des Liniensensors %1 %2",
            "args0": [{
                    "type": "field_dropdown",
                    "name": "sensor",
                    "options": [
                        [
                            "links",
                            "left"
                        ],
                        [
                            "rechts",
                            "right"
                        ],
                        [
                            "mitte",
                            "center"
                        ]
                    ]
                },
                {
                    "type": "input_dummy",
                    "name": "NAME"
                }
            ],
            "output": "Number"
        }

        let that = this
        Blockly.Blocks[this.name] = {
            init: function() {
                this.jsonInit(json);
                this.setColour(that.color)
            }

        }
    }
}